import { render, staticRenderFns } from "./CommonChart.vue?vue&type=template&id=c06cfd82"
import script from "./CommonChart.vue?vue&type=script&lang=js"
export * from "./CommonChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports